module.exports = __webpack_public_path__ + "img/ics_close.3ecaec87.svg";